
import { defineComponent } from 'vue';
import { useField } from 'vee-validate';
import AppFormItem from '@/components/UI/AppFormItem.vue';

export default defineComponent({
  inheritAttrs: false,
  components: { AppFormItem },
  props: {
    checked: { type: Boolean },
    name: { type: String, required: true },
    propError: { type: String, default: '' },
    label: { type: String, default: '' },
    controlClass: { type: String, default: '' },
    alignStart: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { value, errorMessage } = useField(props.name);

    return { value, errorMessage };
  },
});
